import React, { FC } from 'react'

import { Spacing } from '@ucheba/ui/components/Spacing/desktop'

import { Responses, ShowMoreButton } from '../base/styled'

import { IResponsesListProps } from '../types'
import Item from './Item'
import { useResponsesList } from '../bll'

const ResponsesList: FC<IResponsesListProps> = ({
  parentId,
  responses,
  type,
  onAnswerClick,
  rootId,
  rootType,
  itemsLength,
  offset,
  limit,
}) => {
  const { responsesList, showAllAnswers, setShowAllAnswers, representativeInstitution } =
    useResponsesList(responses, parentId)

  return (
    <>
      {responses && responses.length > 0 && (
        <Responses>
          <ul>
            {responsesList.map((response) => (
              <Item
                key={response.id}
                isResponse
                type={type}
                rate={response.rate}
                id={response.id}
                date={response.dateCreated}
                text={response.text}
                faculty={response.faculty}
                program={response.program}
                owner={response.owner}
                responseFor={response.responseFor}
                voteStats={response.voteStats}
                onAnswerClick={() => onAnswerClick(response.id)}
                rootType={rootType}
                rootId={rootId}
                itemsLength={itemsLength}
                limit={limit}
                offset={offset}
                representativeInstitution={representativeInstitution}
              />
            ))}
          </ul>

          {!showAllAnswers && responses.length > 1 && (
            <>
              <Spacing spacing='small' />

              <ShowMoreButton
                block
                view='outline'
                color='white'
                onClick={() => setShowAllAnswers(true)}
              >
                Показать все ответы
              </ShowMoreButton>

              <Spacing spacing='xlarge' />
            </>
          )}
        </Responses>
      )}
    </>
  )
}

export default ResponsesList
